// extracted by mini-css-extract-plugin
export default {"container":"NoItems_container__O9caR","message":"NoItems_message__71xja"};